import {useMutation} from 'react-query';
import axios from 'axios';

interface RegisterUser {
    username: string | any,
    name: string
    password: string
    email: string,
}

export const useRegisterMutation = () => {
    const registerUser = async (values: RegisterUser) => {
        const baseURL = process.env.REACT_APP_BASE_URL;

        // const nonce = await axios.get(`${baseURL}/wp-json/api/get_nonce/?json=get_nonce&controller=user&method=register`).then((response) => {
        //         return response.data?.nonce
        //     }
        // ).catch((err) => {
        //     console.log({err})
        // })


        const queryString = Object.keys(values)
            // @ts-ignore
            .map((key) => key + '=' + values[key])
            .join('&');

        // return await axios.post(`${baseURL}api/user/register/?${queryString}&nonce=${nonce}&insecure=cool&notify=both`);
        // return await axios.post(`${baseURL}/wp-json/sbaj/v1/user/register`,values);
        return await axios.post(`${baseURL}/api/auth/local/register`,values);
    }

    return useMutation('register-user', registerUser)
};

